import './Loader.scss';

export function Loader() {
  return (
    <div className="loader-container">
      <div className="loader">Loading...</div>
    </div>
  );
}
